import { TextDirectionType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';

const LeftKeyCode = 37;
const RightKeyCode = 39;
const UpKeyCode = 38;
const DownKeyCode = 40;

/**
 * 根据文字方向把实际的上下左右 keycode 转为逻辑上的上下左右 keycode
 * @param keyCode
 * @param textDirection
 * @returns
 */
export function convertKeyCodeWithTextDirection(keyCode: number, textDirection: TextDirectionType): number {
    switch (textDirection) {
        case TextDirectionType.VERTICAL:
        case TextDirectionType.ROTATE_90:
        case TextDirectionType.WORD_ART_VERTICAL_RTL: {
            const keCodeMap = {
                [LeftKeyCode]: DownKeyCode,
                [RightKeyCode]: UpKeyCode,
                [UpKeyCode]: LeftKeyCode,
                [DownKeyCode]: RightKeyCode,
            };
            return keCodeMap[keyCode] || keyCode;
        }
        case TextDirectionType.ROTATE_270: {
            const keCodeMap = {
                [LeftKeyCode]: UpKeyCode,
                [RightKeyCode]: DownKeyCode,
                [UpKeyCode]: RightKeyCode,
                [DownKeyCode]: LeftKeyCode,
            };
            return keCodeMap[keyCode] || keyCode;
        }
        case TextDirectionType.WORD_ART_VERTICAL_LTR: {
            const keCodeMap = {
                [LeftKeyCode]: UpKeyCode,
                [RightKeyCode]: DownKeyCode,
                [UpKeyCode]: LeftKeyCode,
                [DownKeyCode]: RightKeyCode,
            };
            return keCodeMap[keyCode] || keyCode;
        }

        case TextDirectionType.HORIZONTAL:
        default: {
            return keyCode;
        }
    }
}
